// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-dialog-content {
  min-height: 122px;
}`, "",{"version":3,"sources":["webpack://./src/app/service/app-loader/app-loader.component.scss","webpack://./../../audit%20module/RedThread/src/app/service/app-loader/app-loader.component.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;ACCJ","sourcesContent":[".mat-dialog-content {\r\n    min-height: 122px;\r\n  }",".mat-dialog-content {\n  min-height: 122px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
